import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from 'common/icon/Icon';

const HeaderCheckout = ({
    className
}) => {
    const classes = classNames(
        'Header',
        'HeaderCheckout',
        className
    );

    return (
        <header
            className={classes}
            role="banner"
        >
            <div className="Navigation container">
                <div className="Navigation-bar Navigation-checkout">
                    <Icon
                        name="spothero"
                        size={56}
                    />
                    <div className="HeaderCheckout-text-with-lock">
                        <Icon
                            name="lock"
                            size={14}
                        />
                        <span className="HeaderCheckout-secure-checkout">Secure Checkout</span>
                    </div>
                </div>
            </div>
        </header>
    );
};

HeaderCheckout.propTypes = {
    className: PropTypes.string
};

export default HeaderCheckout;
